import { MainTitle } from "@/components/main-title";
import { SettingsNav } from "@/components/settings-nav";
import { settingsLinks } from "@/constants";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/$org/settings")({
  component: SettingsLayoutComponent,
  beforeLoad: ({ location, params }) => {
    const targetPath = `/${params.org}/settings`;
    if (location.pathname === targetPath) {
      const path = `/${params.org}${settingsLinks.get("organization")?.url}`;
      throw redirect({ to: path });
    }
  },
});

function SettingsLayoutComponent() {
  const { t } = useTranslation();
  return (
    <div>
      <MainTitle title={t("nav.settings")} />
      <SettingsNav />
      <Outlet />
    </div>
  );
}
